/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */
if(!window.GS) GS={};
if(!window.GS.Filters) GS.Filters={};
(function(){
    var f = new Class({
        //Extends: GS.BaseClass,
        Extends: GS.Filters.BaseFilter,
        class_name:'GS.Filters.ImageFilters',
        options:{
            'dx': 0,
            'hue' : 0,
            'contrast':0,
            'colorize' : 0,
            'color':{'r':255,'g':0,'b':0},
            'contrast_matrix':[],
            'brightness':0,
            'brightness_matrix':[],
            'staturation': 0,
            'staturation_matrix':[],
            'sepia':false,
            'bw':false,
            'shadow':{
                'dx': 0,
                'dy':0,
                'color': '#000',
                'blur':10,
                'inType':'SourceAlpha'
            }
        },
        filter: {
            'id':0,
            'container':null,
            'saturation':null,
            'brightness':null,
            'color':null,
            'contrast':null,
            'compTransfert' : null
            
        }
    });

    /**
     * Apply/Attach filter to element
     * @param {SVG Element} ele
     * @returns {void}
     */
    f.prototype.applyTo=function(ele){
        this.ele = (ele.node || ele);
        this.ele.setAttribute('filter',"url('#"+this.filter.id+"')");
        if(this.options.personalization){
            this.ele.removeAttribute('filter');
            this.ele.parentNode.setAttribute('filter',"url('#"+this.filter.id+"')");
        }
    };


    f.prototype.createFilter=function(){
        var w = parseFloat(this.defs.ownerSVGElement.getAttribute('width')),
            h = parseFloat(this.defs.ownerSVGElement.getAttribute('height'));   
        var fID,
            //f=new Element('filter',{'id':this.filter.id,'color-interpolation-filters':'sRGB','filterUnits': "objectBoundingBox", 'x':'-150%','y':'-150%','width':'300%','height':'300%'/*,'enable-background':'accumulate'*/});
            f=new Element('filter',{'id':this.filter.id,'color-interpolation-filters':'sRGB','filterUnits': "userSpaceOnUse", 'x': -w,'y': -h,'width': 3*w,'height': 3*h/*,'enable-background':'accumulate'*/});
            
        //f=new Element('filter',{'id':this.filter.id,'color-interpolation-filters':'sRGB'/*,'enable-background':'accumulate'*/});

        this.filter.container=f;
        this.addColorFilter();
        this.defs.adopt(f);
    };
    
    
    /**
    * Create Color Filter element     
    * @returns {void}
    */
    f.prototype.addColorFilterOld=function(){
        var fID,saturation,brightness,contrast,sepia,bw,feMerge,feMergeComposit,
            _compTransfert,_compTransfertPersonalization, fnR,fnG,fnB,_hue,feGaussianBlur,feOffset,feColorMatrix,feMerge,feMergeShadow,feMergeSurce,cMatrix,_color;
        //console.debug(this.options.colors);
        
        //Deprecated....
        /*_compTransfert = new Element('feComponentTransfer',{'in':'SourceGraphic','result':'transformed'});
        fnR =  new Element('feFuncR',{'type':'table','tableValues': '0.1 0.33 1'});
        fnG =  new Element('feFuncG',{'type':'table','tableValues': '0.1 0.33 1'});
        fnB =  new Element('feFuncB',{'type':'table','tableValues': '0.1 0.33 1'});
        _compTransfert.adopt([fnR,fnG,fnB]);
        this.filter.compTransfert=_compTransfert;*/

        _compTransfertPersonalization = new Element('feComponentTransfer',{'in':'SourceAlpha','result':'transformedPersonalization'});
        this.funcR = fnR =  new Element('feFuncR',{'type':'table','tableValues': '0.1 0.33 1'});
        this.funcG = fnG =  new Element('feFuncG',{'type':'table','tableValues': '0.1 0.33 1'});
        this.funcB = fnB =  new Element('feFuncB',{'type':'table','tableValues': '0.1 0.33 1'});
        _compTransfertPersonalization.adopt([fnR,fnG,fnB]);
        this.filter.compTransfertPersonalization = _compTransfertPersonalization;


        /**
         <!-- PERSONALIZATION FILTERS -->

         <feColorMatrix in="SourceAlpha" type="matrix" result="transparent" color-interpolation-filters="sRGB"
         values="1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 0 0"></feColorMatrix>

         <feComponentTransfer in="SourceAlpha" result="white">
         <feFuncR type="table" tableValues="1 1"></feFuncR>
         <feFuncG type="table" tableValues="1 1"></feFuncG>
         <feFuncB type="table" tableValues="1 1"></feFuncB>
         </feComponentTransfer>
         <feColorMatrix in="white" type="matrix" result="white" color-interpolation-filters="sRGB"
         values="1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"></feColorMatrix>

         <!-- COLORIZE IMAGE (NO UV COLOR) -->
         <feComponentTransfer in="SourceGraphic" result="color2">
         <feFuncR type="table" tableValues="0 1"></feFuncR>
         <feFuncG type="table" tableValues="0.7490196078431373 1"></feFuncG>
         <feFuncB type="table" tableValues="0 1"></feFuncB>
         </feComponentTransfer>

         <!-- COLORIZE IMAGE UV COLOR -->
         <feComponentTransfer in="SourceAlpha" result="color">
         <feFuncR type="table" tableValues="1 1"></feFuncR>
         <feFuncG type="table" tableValues="1 1"></feFuncG>
         <feFuncB type="table" tableValues="1 1"></feFuncB>
         </feComponentTransfer>

         <feComponentTransfer in="SourceAlpha" result="varnish">
         <feFuncR type="table" tableValues="0.9 0.9"></feFuncR>
         <feFuncG type="table" tableValues="0.9 0.9"></feFuncG>
         <feFuncB type="table" tableValues="0.9 0.9"></feFuncB>
         </feComponentTransfer>

         <feColorMatrix in="varnish" type="matrix" result="varnish" color-interpolation-filters="sRGB"
         values="1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 0.5 0"></feColorMatrix>

         <!-- PERSONALIZATION FILTERS -->

         */


        _compTransfert = new Element('feColorMatrix',{'type':'matrix','in':'SourceGraphic','result':'trasformed2','values':'0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0 0 0 1 0'});
        this.filter.compTransfert=_compTransfert;
        
        
        
        
        _hue = new Element('feColorMatrix',{'in':'SourceGraphic','result':'transformed','type':'hueRotate','values':"0"});
        this.filter.hue=_hue;
        this.setImageHue(this.options.hue);
        
        this.setObjectColor(this.options.color,this.options.colorize);
        _color = new Element('feColorMatrix',{'in':'transformed','result':'transformed','type':'matrix','values':this.options.color_matrix.join(' ')});
        this.filter.color=_color;
        
        //var sourceGraphics = this.options.colorize ? 'transformed' : 'SourceGraphic';
        saturation = new Element('feColorMatrix',{'in':'transformed','type':'matrix','result':'transformed','data-type':'saturation','values':'1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0'});
        this.setImageSaturation(this.options.saturation);
        saturation.set('values',this.options.saturation_matrix.join(' '));
        this.filter.saturation=saturation;

        brightness = new Element('feColorMatrix',{'in':'transformed','type':'matrix','result':'transformed','values':'1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0'});
        this.setImageBrightness(this.options.brightness);
        brightness.set('values',this.options.brightness_matrix.join(' '));
        this.filter.brightness=brightness;

        contrast = new Element('feColorMatrix',{'in':'transformed','type':'matrix','result':'transformed','values':''});
        this.setImageContrast(this.options.contrast);
        contrast.set('values',this.options.contrast_matrix.join(' '));
        this.filter.contrast=contrast;
        
        

        sepia = new Element('feColorMatrix',{'in':'transformed','result':'transformed','type':'matrix','values':''});
        this.convertToSepia(this.options.sepia);
        sepia.set('values',this.options.sepia_matrix.join(' '));
        this.filter.sepia=sepia;

        bw = new Element('feColorMatrix',{'in':'transformed','type':'matrix','result':'transformed','values':''});
        this.convertToBW(this.options.bw);
        bw.set('values',this.options.bw_matrix.join(' '));
        this.filter.bw=bw;
        

        /**
        <!-- IF EXIST PERSONALIZATION -->
            <feBlend in="white" in2="color" result="transformed2" mode="normal"/>
            <feBlend in="color" in2="varnish" result="transformed2" mode="multiply"/>
            <!-- IF EXIST PERSONALIZATION -->
         */

        feMerge = new Element('feMerge');
        feMergeComposit = new Element('feMergeNode',{'in':'transformed','result':'transformed','mode':'normal'});
        feMerge.adopt(feMergeComposit);
        
        
        //Add Gaussian Blur Filter
        feGaussianBlur = new Element('feGaussianBlur',{'in':'SourceAlpha','result':'blur','stdDeviation':this.options.shadow.blur});
        this.filter.blur=feGaussianBlur;

        //Add Offset Filter
        feOffset = new Element('feOffset',{'in':'blur','result':'shadow','dx':this.options.shadow.dx,'dy':this.options.shadow.dy});
        this.filter.offset=feOffset;

        //Add Color Matrix Filter
        /*if(!this.options.shadow.display){
            cMatrix="0 0 0 {r} 0 0 0 0 {g} 0 0 0 0 {b} 0 0 0 0 0 0".substitute(this.options.shadow.color);
        }else{
            cMatrix="0 0 0 {r} 0 0 0 0 {g} 0 0 0 0 {b} 0 0 0 0 {a} 0".substitute(this.options.shadow.color);
        }*/
        feColorMatrix = new Element('feColorMatrix',{'in':'shadow','result':'cloredShadow','type':'matrix','values': this.getShadowColorMatrix(this.options.shadow.color, this.options.shadow.display)});
        this.filter.shadow_color=feColorMatrix;

        //Merging Filters
        feMerge = new Element('feMerge');
        feMergeShadow = new Element('feMergeNode',{'in':'cloredShadow','mode':'normal'});
        feMergeSurce = new Element('feMergeNode',{'in':'transformed','mode':'normal'});
        this.feMergeSurce = feMergeSurce;
        feMerge.adopt([feMergeShadow,feMergeSurce]);

        if(this.options.personalization) this.applyPersonalizationFilter(this.options.personalization, this.options.shadow);

        this.filter.container.adopt([_compTransfertPersonalization, _compTransfert,_hue,saturation,brightness,contrast,sepia,bw,_color,feGaussianBlur,feOffset,feColorMatrix,feMerge]);
    };


    f.prototype.addColorFilter=function(){
        var fID,saturation,brightness,contrast,sepia,bw,feMerge,feMergeComposit,
            _compTransfert,_compTransfertPersonalization, fnR,fnG,fnB,_hue,feGaussianBlur,feOffset,feColorMatrix,feMerge,feMergeShadow,feMergeSurce,cMatrix,_color;
        //console.debug(this.options.colors);

        //Deprecated....
        /*_compTransfert = new Element('feComponentTransfer',{'in':'SourceGraphic','result':'transformed'});
        fnR =  new Element('feFuncR',{'type':'table','tableValues': '0.1 0.33 1'});
        fnG =  new Element('feFuncG',{'type':'table','tableValues': '0.1 0.33 1'});
        fnB =  new Element('feFuncB',{'type':'table','tableValues': '0.1 0.33 1'});
        _compTransfert.adopt([fnR,fnG,fnB]);
        this.filter.compTransfert=_compTransfert;*/


        var whiteLevel = new Element('feComponentTransfer', {'in': "SourceAlpha", 'result': 'white'});
        whiteLevel.innerHTML = '\n'+
            '   <feFuncR type="table" tableValues="1 1"></feFuncR>\n' +
            '   <feFuncG type="table" tableValues="1 1"></feFuncG>\n' +
            '   <feFuncB type="table" tableValues="1 1"></feFuncB>';


        // If no UV use SourceGraphic otherwise use SourceAlpha...
        var coloredImage = new Element('feComponentTransfer', {'in': "SourceGraphic", 'result': 'colored'});
        var coloredR = new Element('feFuncR',{'type':'table','tableValues': '0.1 0.33 1'});
        var coloredG = new Element('feFuncG',{'type':'table','tableValues': '0.1 0.33 1'});
        var coloredB = new Element('feFuncB',{'type':'table','tableValues': '0.1 0.33 1'});
        coloredImage.adopt([coloredR,coloredG,coloredB]);



        _compTransfertPersonalization = new Element('feComponentTransfer',{'in':'SourceAlpha','result':'transformedPersonalization'});
        this.funcR = fnR =  new Element('feFuncR',{'type':'table','tableValues': '0.1 0.33 1'});
        this.funcG = fnG =  new Element('feFuncG',{'type':'table','tableValues': '0.1 0.33 1'});
        this.funcB = fnB =  new Element('feFuncB',{'type':'table','tableValues': '0.1 0.33 1'});
        _compTransfertPersonalization.adopt([fnR,fnG,fnB]);
        this.filter.compTransfertPersonalization = _compTransfertPersonalization;


        /**
         <!-- PERSONALIZATION FILTERS -->

         <feColorMatrix in="SourceAlpha" type="matrix" result="transparent" color-interpolation-filters="sRGB"
         values="1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 0 0"></feColorMatrix>

         <feComponentTransfer in="SourceAlpha" result="white">
         <feFuncR type="table" tableValues="1 1"></feFuncR>
         <feFuncG type="table" tableValues="1 1"></feFuncG>
         <feFuncB type="table" tableValues="1 1"></feFuncB>
         </feComponentTransfer>
         <feColorMatrix in="white" type="matrix" result="white" color-interpolation-filters="sRGB"
         values="1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"></feColorMatrix>

         <!-- COLORIZE IMAGE (NO UV COLOR) -->
         <feComponentTransfer in="SourceGraphic" result="color2">
         <feFuncR type="table" tableValues="0 1"></feFuncR>
         <feFuncG type="table" tableValues="0.7490196078431373 1"></feFuncG>
         <feFuncB type="table" tableValues="0 1"></feFuncB>
         </feComponentTransfer>

         <!-- COLORIZE IMAGE UV COLOR -->
         <feComponentTransfer in="SourceAlpha" result="color">
         <feFuncR type="table" tableValues="1 1"></feFuncR>
         <feFuncG type="table" tableValues="1 1"></feFuncG>
         <feFuncB type="table" tableValues="1 1"></feFuncB>
         </feComponentTransfer>

         <feComponentTransfer in="SourceAlpha" result="varnish">
         <feFuncR type="table" tableValues="0.9 0.9"></feFuncR>
         <feFuncG type="table" tableValues="0.9 0.9"></feFuncG>
         <feFuncB type="table" tableValues="0.9 0.9"></feFuncB>
         </feComponentTransfer>

         <feColorMatrix in="varnish" type="matrix" result="varnish" color-interpolation-filters="sRGB"
         values="1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 0.5 0"></feColorMatrix>

         <!-- PERSONALIZATION FILTERS -->

         */


        _compTransfert = new Element('feColorMatrix',{'type':'matrix','in':'SourceGraphic','result':'trasformed2','values':'0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0 0 0 1 0'});
        this.filter.compTransfert=_compTransfert;




        _hue = new Element('feColorMatrix',{'in':'SourceGraphic','result':'transformed','type':'hueRotate','values':"0"});
        this.filter.hue=_hue;
        this.setImageHue(this.options.hue);

        this.setObjectColor(this.options.color,this.options.colorize);
        _color = new Element('feColorMatrix',{'in':'transformed','result':'transformed','type':'matrix','values':this.options.color_matrix.join(' ')});
        this.filter.color=_color;

        //var sourceGraphics = this.options.colorize ? 'transformed' : 'SourceGraphic';
        saturation = new Element('feColorMatrix',{'in':'transformed','type':'matrix','result':'transformed','data-type':'saturation','values':'1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0'});
        this.setImageSaturation(this.options.saturation);
        saturation.set('values',this.options.saturation_matrix.join(' '));
        this.filter.saturation=saturation;

        brightness = new Element('feColorMatrix',{'in':'transformed','type':'matrix','result':'transformed','values':'1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0'});
        this.setImageBrightness(this.options.brightness);
        brightness.set('values',this.options.brightness_matrix.join(' '));
        this.filter.brightness=brightness;

        contrast = new Element('feColorMatrix',{'in':'transformed','type':'matrix','result':'transformed','values':''});
        this.setImageContrast(this.options.contrast);
        contrast.set('values',this.options.contrast_matrix.join(' '));
        this.filter.contrast=contrast;



        sepia = new Element('feColorMatrix',{'in':'transformed','result':'transformed','type':'matrix','values':''});
        this.convertToSepia(this.options.sepia);
        sepia.set('values',this.options.sepia_matrix.join(' '));
        this.filter.sepia=sepia;

        bw = new Element('feColorMatrix',{'in':'transformed','type':'matrix','result':'transformed','values':''});
        this.convertToBW(this.options.bw);
        bw.set('values',this.options.bw_matrix.join(' '));
        this.filter.bw=bw;


        /**
         <!-- IF EXIST PERSONALIZATION -->
         <feBlend in="white" in2="color" result="transformed2" mode="normal"/>
         <feBlend in="color" in2="varnish" result="transformed2" mode="multiply"/>
         <!-- IF EXIST PERSONALIZATION -->
         */

        feMerge = new Element('feMerge');
        feMergeComposit = new Element('feMergeNode',{'in':'transformed','result':'transformed','mode':'normal'});
        feMerge.adopt(feMergeComposit);


        //Add Gaussian Blur Filter
        feGaussianBlur = new Element('feGaussianBlur',{'in':'SourceAlpha','result':'blur','stdDeviation':this.options.shadow.blur});
        this.filter.blur=feGaussianBlur;

        //Add Offset Filter
        feOffset = new Element('feOffset',{'in':'blur','result':'shadow','dx':this.options.shadow.dx,'dy':this.options.shadow.dy});
        this.filter.offset=feOffset;

        //Add Color Matrix Filter
        /*if(!this.options.shadow.display){
            cMatrix="0 0 0 {r} 0 0 0 0 {g} 0 0 0 0 {b} 0 0 0 0 0 0".substitute(this.options.shadow.color);
        }else{
            cMatrix="0 0 0 {r} 0 0 0 0 {g} 0 0 0 0 {b} 0 0 0 0 {a} 0".substitute(this.options.shadow.color);
        }*/
        feColorMatrix = new Element('feColorMatrix',{'in':'shadow','result':'cloredShadow','type':'matrix','values': this.getShadowColorMatrix(this.options.shadow.color, this.options.shadow.display)});
        this.filter.shadow_color=feColorMatrix;

        //Merging Filters
        feMerge = new Element('feMerge');
        feMergeShadow = new Element('feMergeNode',{'in':'cloredShadow','mode':'normal'});
        feMergeSurce = new Element('feMergeNode',{'in':'transformed','mode':'normal'});
        this.feMergeSurce = feMergeSurce;
        feMerge.adopt([feMergeShadow,feMergeSurce]);

        if(this.options.personalization) this.applyPersonalizationFilter(this.options.personalization, this.options.shadow);

        this.filter.container.adopt([_compTransfertPersonalization, _compTransfert,_hue,saturation,brightness,contrast,sepia,bw,_color,feGaussianBlur,feOffset,feColorMatrix,feMerge]);
    };

    f.prototype.getShadowColorMatrix = function (color, display){
        var cMatrix, c;
        if(!display){
            cMatrix="0 0 0 {r} 0 0 0 0 {g} 0 0 0 0 {b} 0 0 0 0 0 0".substitute(color);
        }else{
            cMatrix="0 0 0 {r} 0 0 0 0 {g} 0 0 0 0 {b} 0 0 0 0 {a} 0".substitute(color);
        }

        return cMatrix;
    }



    f.prototype.applyPersonalizationFilter = function(obj, shadow){
        if(this.ele){
            this.ele.removeAttribute('filter');
            this.ele.parentNode.setAttribute('filter',"url('#"+this.filter.id+"')");
        }
        console.warn('APPLY PERSONALIZATION:', shadow);
        var c = {
            'r': ((obj && obj.color) ? obj.color.r : 0),
            'g': ((obj && obj.color) ? obj.color.g : 0),
            'b': ((obj && obj.color) ? obj.color.b : 0),
            'a': 0
        };


        this.filter.compTransfertPersonalization.setAttribute('result', 'transformedPersonalization');
        this.remapColor(obj.color,0);
        this.remapColor(null, 1);
        this.feMergeSurce.setAttribute('in', 'transformedPersonalization');
        this.filter.shadow_color.setAttribute('values', this.getShadowColorMatrix(c, 0));
        this.feMergeSurce.setAttribute('in', 'transformedPersonalization');
    };

    f.prototype.update=function(obj){

        console.debug('@ UPDATE IMAGE FILTERS', obj);
        if(!obj.personalization)  {
            this.ele.parentNode.removeAttribute('filter');
            this.ele.setAttribute('filter',"url('#"+this.filter.id+"')");
        }

        if(!obj.personalization) {
            //this.filter.compTransfertPersonalization.setAttribute('result', 'transformed3');
            this.feMergeSurce.setAttribute('in', 'transformed');
            //this.filter.compTransfert.setAttribute('in', 'SourceGraphics');
            this.setObjectColor(obj.color, obj.colorize);
            if (obj.colorize) {
                this.filter.compTransfert.setAttribute('out', 'transformed');
                this.filter.hue.setAttribute('in', 'transformed');
            } else {
                this.filter.compTransfert.setAttribute('out', 'transformed2');
                this.filter.hue.setAttribute('in', 'SourceGraphic');
            }

            this.setImageHue(obj.hue);

            this.setImageBrightness(obj.brightness);
            this.setImageContrast(obj.contrast);
            this.setImageSaturation(obj.saturation);
            this.convertToSepia(obj.sepia);
            this.convertToBW(obj.bw);

            // console.debug(this.convertHslToRgb({'h':(obj.hue<0) ? 360+obj.hue : 360-obj.hue,'s':obj.saturation,'l':obj.brightness}));
            if (obj.colorize) {
                this.convertToBW(1);
                //this.setImageSaturation(-180);
            } else {
                this.setObjectColor(obj.color, obj.colorize);
            }

            this.filter.color.set('values', this.options.color_matrix.join(' '));


            this.filter.offset.setAttribute('dx', obj.shadow.dx);
            this.filter.offset.setAttribute('dy', obj.shadow.dy);
            this.filter.blur.setAttribute('stdDeviation', obj.shadow.blur);
            var cMatrix;
            if (!obj.shadow.display) {
                cMatrix = "0 0 0 {r} 0 0 0 0 {g} 0 0 0 0 {b} 0 0 0 0 0 0".substitute(obj.shadow.color);
                //alert('hide shadow....');
            } else {
                cMatrix = "0 0 0 {r} 0 0 0 0 {g} 0 0 0 0 {b} 0 0 0 0 {a} 0".substitute(obj.shadow.color);
            }

            this.filter.shadow_color.setAttribute("values", cMatrix);

            this.filter.saturation.set('values', this.options.saturation_matrix.join(' '));
            this.filter.brightness.set('values', this.options.brightness_matrix.join(' '));
            this.filter.contrast.set('values', this.options.contrast_matrix.join(' '));
            this.filter.sepia.set('values', this.options.sepia_matrix.join(' '));
            this.filter.bw.set('values', this.options.bw_matrix.join(' '));
        }else{
            this.applyPersonalizationFilter(obj.personalization, obj.shadow.display, obj.shadow.color.a || 1);
        }
        
    };


    f.prototype.remapColor = function(color,index) {
        var tableValues;

        if(!color){
            switch(index){
                case 0:
                    color = {'r' : 0, 'g' : 0, 'b' : 0};
                    break;
                case 1:
                    color = {'r' : 255, 'g': 255, 'b' : 255};
                    break;
            }
        }

        //console.warn('Remap color %s using',index,color);
        //Remap red....
        tableValues = this.funcR.getAttribute('tableValues').split(' ');
        tableValues[index] = color.r / 255;
        this.funcR.setAttribute('tableValues', tableValues.join(' '));

        //Remap green....
        tableValues = this.funcG.getAttribute('tableValues').split(' ');
        tableValues[index] = color.g / 255;
        this.funcG.setAttribute('tableValues', tableValues.join(' '));

        //Remap blue....
        tableValues = this.funcB.getAttribute('tableValues').split(' ');
        tableValues[index] = color.b / 255;
        this.funcB.setAttribute('tableValues', tableValues.join(' '));
    };
    
    f.prototype.convertHslToRgb = function (iHsl)
    {
        var min, sv, sextant, fract, vsf;
        
        
        
        var v = (iHsl.l <= 0.5) ? (iHsl.l * (1 + iHsl.s)) : (iHsl.l + iHsl.s - iHsl.l * iHsl.s);
        
        //console.debug(iHsl,v);
        
        if (v === 0)
            return { Red: 0, Green: 0, Blue: 0 };

        min = 2 * iHsl.l - v;
        sv = (v - min) / v;
        var h = (6 * iHsl.h) % 6;
        sextant = Math.floor(h);
        fract = h - sextant;
        vsf = v * sv * fract;

        switch (sextant)
        {
            case 0: return { r: v, g: min + vsf, b: min };
            case 1: return { r: v - vsf, g: v, b: min };
            case 2: return { r: min, g: v, b: min + vsf };
            case 3: return { r: min, g: v - vsf, b: v };
            case 4: return { r: min + vsf, g: min, b: v };
            case 5: return { r: v, g: min, b: v - vsf };
        }
    };
    
    
    f.prototype.setImageHue=function(hue){
         this.filter.hue.setAttribute('values',hue);
    };
    
    /**
    * Change object color
    * @param {object} color          :rgb object
    * @returns {void}
    */
    f.prototype.setObjectColor=function(color,colorize){
        //console.debug('Set object color from',color);
        var cMatrix = [],
          r = (colorize) ? color.r/255 : 1,
          g = (colorize) ? color.g/255 : 1,
          b = (colorize) ? color.b/255 : 1,
          a = (!isNaN(color.a)) ? color.a : 1;
        
        cMatrix = cMatrix.concat([r, 0, 0, 0, 0]);    // red
        cMatrix = cMatrix.concat([0, g, 0, 0, 0]);    // green
        cMatrix = cMatrix.concat([0, 0, b, 0, 0]);    // blue
        cMatrix = cMatrix.concat([0, 0, 0, a, 0]);          // alpha

        this.options.color_matrix=cMatrix;
    };
    
    /**
     * 
     * @param {boolean} v
     * @returns {void}
     */
    f.prototype.convertToSepia=function(v){
        var cMatrix = [],
            amount = 1,
            r=(v) ? (0.393 + 0.607 * (1 - amount)) : 1,
            g=(v) ? (0.686 + 0.314 * (1 - amount)) : 1,
            b=(v) ? (0.131 + 0.869 * (1 - amount)) : 1,

            rx=(v) ? (0.769 - 0.769 * (1 - amount)) : 0,
            ry=(v) ? (0.189 - 0.189 * (1 - amount)) : 0,

            gx=(v) ? (0.349 - 0.349 * (1 - amount)) : 0,
            gy=(v) ? (0.168 - 0.168 * (1 - amount)) : 0,

            bx=(v) ? (0.272 - 0.272 * (1 - amount)) : 0,
            by=(v) ? (0.534 - 0.534 * (1 - amount)) : 0;
        
       
        
        cMatrix = cMatrix.concat([r , rx, ry, 0, 0]);    // red
        cMatrix = cMatrix.concat([gx, g, gy, 0, 0]);    // green
        cMatrix = cMatrix.concat([bx, by, b, 0, 0]);    // blue
        cMatrix = cMatrix.concat([0, 0, 0, 1, 0]);          // alpha 
        this.options.sepia_matrix=cMatrix;
     };
 
    /**
    * 
    * @param {boolean} v
    * @returns {void}
    */
   f.prototype.convertToBW=function(v){
      //b&w matrix [0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0]
      //normal matrix [1 0 0 0 0 0 0 1 0 0 0 0 0 0 1 0 0 0 0 0 1 0] 
       var cMatrix = [],
           r=(v) ? 0.33 : 1,
           g=(v) ? 0.33 : 1,
           b=(v) ? 0.33 : 1,

           rx=(v) ? 0.33 : 0,
           ry=(v) ? 0.33 : 0,

           gx=(v) ? 0.33 : 0,
           gy=(v) ? 0.33 : 0,

           bx=(v) ? 0.33 : 0,
           by=(v) ? 0.33 : 0;

       cMatrix = cMatrix.concat([r , rx, ry, 0, 0]);    // red
       cMatrix = cMatrix.concat([gx, g, gy, 0, 0]);    // green
       cMatrix = cMatrix.concat([bx, by, b, 0, 0]);    // blue
       cMatrix = cMatrix.concat([0, 0, 0, 1, 0]);          // alpha 


       this.options.bw_matrix=cMatrix;
    };

    /**
    * Change image saturation
    * @param {number} v          :[-100,100] default to 0
    * @returns {void}
    */
    f.prototype.setImageSaturation=function(v){
        var cMatrix = [],lumaR,lumaG,lumaB,i,r,g,b;
        lumaR = 0.212671;
        lumaG = 0.71516;
        lumaB = 0.072169;
        v=v/100+1;

        i = (1 - v);
        r = (i * lumaR);
        g = (i * lumaG);
        b = (i * lumaB);

        cMatrix = cMatrix.concat([(r + v), g, b, 0, 0]);    // red
        cMatrix = cMatrix.concat([r, (g + v), b, 0, 0]);    // green
        cMatrix = cMatrix.concat([r, g, (b + v), 0, 0]);    // blue
        cMatrix = cMatrix.concat([0, 0, 0, 1, 0]);          // alpha

        this.options.saturation_matrix=cMatrix;
    };


    /**
    * Set image Brightness
    * @param {number} s
    * @returns {void}
    */
    f.prototype.setImageBrightness=function(s){
        var cMatrix=[];
        s=-Number(s)/100;

        cMatrix=cMatrix.concat([1,0,0,0,s]);// red
        cMatrix=cMatrix.concat([0,1,0,0,s]);// green
        cMatrix=cMatrix.concat([0,0,1,0,s]);// blue
        cMatrix=cMatrix.concat([0,0,0,1,0]);// alpha

        this.options.brightness_matrix=cMatrix;
    };

    /**
    * Set the image contrast
    * 
    * @param {Number} v          :[-100,100] default to 0
    * @returns {void}
    */
    f.prototype.setImageContrast=function(v){
        //console.debug('Set image contrast...',v);
        var cMatrix=[],s_d;
        v=Number(v);
        v /= 100;

        s = v + 1;
        _d = 0.5*(1 - s);

        cMatrix = cMatrix.concat([s, 0, 0, 0, _d]);  // red
        cMatrix = cMatrix.concat([0, s, 0, 0, _d]);  // green
        cMatrix = cMatrix.concat([0, 0, s, 0, _d]);  // blue
        cMatrix = cMatrix.concat([0, 0, 0, 1, 0]);  // alpha

        this.options.contrast_matrix=cMatrix;
    };
    
    this.ImageFilters = f;
}.call(GS.Filters));
